import { TrackedLink } from "@/components/analytics/TrackedLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-solid-svg-icons";

/**
 * Full-width black creator-CTA band anchored between the social section and the
 * lead form. `relative` so it paints above (and slides up over) the pinned
 * social section during the scroll cascade, and it leads straight into the
 * lead form below it.
 */
const CreatorCalloutBand = () => {
  return (
    <section className="relative bg-black">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 sm:py-10 md:py-14 flex flex-col items-center gap-5 text-center sm:flex-row sm:justify-between sm:text-left">
        <p className="text-lg md:text-2xl font-medium text-white">
          Want to shoot and post highlights like these?
        </p>
        <TrackedLink
          ctaId="become_a_creator"
          ctaLocation="creator_callout_band"
          to="/become-a-creator"
          className="shrink-0 inline-flex items-center gap-2.5 rounded-full border-2 border-white px-7 py-3 text-sm md:text-base font-semibold text-white transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black"
        >
          Become a Creator
          <FontAwesomeIcon icon={faArrowRight} className="h-4 w-4" />
        </TrackedLink>
      </div>
    </section>
  );
};

export default CreatorCalloutBand;
